module.exports = __webpack_public_path__ + "static/media/gyms-marker-map.f9bc31ac.png";